function utc_timestamp() {
    var now = new Date;
    return now.toUTCString();
};


function cache_timeline_width() {
    var windowRange = timeline.getWindow();
    localStorage.setItem('start', windowRange.start.toISOString());
    localStorage.setItem('end', windowRange.end.toISOString());
}


function get_timeline_bounds(scaleToStart, scaleToEnd) {
    // Positions the start and end time around now, according to how long the window was before.
    // `scaleToStart` and `scaleToEnd` are the proportions of the timelne that should show up
    // before now and after now. For example, passing in a value of 0.5 for both would center the
    // timeline around now.
    var old_start = new Date(localStorage.getItem('start'));
    var old_end = new Date(localStorage.getItem('end'));
    var now = new Date(utc_timestamp());
    var timeline_bounds = {
        start: new Date(now.getTime() - (old_end.getTime() - old_start.getTime()) * scaleToStart),
         end: new Date(now.getTime() + (old_end.getTime() - old_start.getTime()) * scaleToEnd)
    };
    return timeline_bounds;
}

function cache_checkbox_value(t, cache_key) {
    localStorage.setItem(cache_key, t.checked);
    location.reload();
}

function create_legend_div(logged_in, admin) {
    var legend_elements = define_legend_elements(logged_in, admin);
    var legend_container = document.getElementById("legend");
    var legend = create_legend(legend_container);
    for (const key in legend_elements) {
        add_legend_element(legend, legend_elements[key], key);
    }
    return;
}


function add_legend_element(legend, legend_element, key) {
    var legend_element_container = create_legend_element_container(legend, legend_element);
    var icon_container = create_icon_container(legend_element_container, legend_element, key);
    create_description_container(legend_element_container, legend_element);
    return;
}


function create_description_container(legend_element_container, legend_element) {
    var description_container = document.createElement("div");
    description_container.className = "description-container";
    description_container.innerHTML = legend_element.label;
    legend_element_container.appendChild(description_container);
    return;
}


function create_icon_container(legend_element_container, legend_element, key) {
    var icon_container = document.createElement("div");
    icon_container.className = "icon-container";
    legend_element_container.appendChild(icon_container);
    create_legend_block(legend_element, icon_container, key);
    return icon_container;
}


function create_legend_block(legend_element, icon_container, key) {
    var legend_block = document.createElement("div");
    if (legend_element.type === "observation") {
        legend_block.className = "legend-observation " + key;
    } else {
        legend_block.className = "legend-background " + key;
    }
    icon_container.appendChild(legend_block);
    return;
}


function create_legend_element_container(legend, legend_element) {
    var legend_element_container = document.createElement("div");
    legend_element_container.className = "col-sm-4 col-md-3 col-lg-2 col-xl-1 legend-element-container";
    legend_element_container.title = legend_element.title; //tooltip
    legend.appendChild(legend_element_container);
    return legend_element_container;
}


function create_legend(legend_container) {
    var legend = document.createElement("div");
    legend.className = "row";
    legend.id = "legend_div";
    legend_container.appendChild(legend);
    return legend;
}


function define_legend_elements(logged_in, admin) {
    var legend_elements = {
        'observation-completed' :
            {label: 'Observation completed',
            type: 'observation',
            title: 'All configurations of the observation have completed'},
        'observation-failed' :
            {label: 'Observation failed',
            type: 'observation',
            title: 'All attempted configurations of observation have failed'},
        'observation-aborted' :
            {label: 'Observation aborted',
            type: 'observation',
            title: 'Observation is flagged as aborted'},
        'observation-future' :
            {label: 'Future observation',
            type: 'observation',
            title: 'Observation is scheduled to begin in the future'},
        'observation-calibrating-past' :
            {label: 'Calibration observation (completed)',
            type: 'observation',
            title: 'Telescope was scheduled to perform calibration'},
        'observation-calibrating-failed' :
            {label: 'Calibration observation (failed)',
            type: 'observation',
            title: 'Telescope calibration failed'},
        'observation-calibrating-future' :
            {label: 'Calibration observation (future)',
            type: 'observation',
            title: 'Telescope is scheduled to perform calibration'},
        'sun-up' :
            {label: 'Sun up',
            type: 'background',
            title: 'Day time at site (from nautical dawn to nautical dusk)'},
        'weather' :
            {label: 'Weather event',
            type: 'background',
            title: 'The site has logged a weather event (hover over event for details)'},
        'downtime' :
            {label: 'Downtime',
            type: 'background',
            title: 'The telescope is not available to be scheduled (hover over event for reason)'},
        'not-schedulable-label' :
            {label: 'Not schedulable',
            type: 'background',
            title: 'None of the telescope\'s instruments are currently scheduled by the scheduler'}
    };
    if (logged_in) {
        legend_elements['owned'] =
                    {label: 'My observation',
                    type: 'background',
                    title: 'Request belongs to Observing Portal profile'};
    }
    if (logged_in && admin) {
        legend_elements['observation-not-attempted'] =
                    {label: 'Not Attempted',
                    type: 'observation',
                    title: 'Observation marked as NOT_ATTEMPTED in the LCO Portal'};
    }
    return legend_elements;
}


function create_checkbox(toggled_variable, variable_name, title) {

    var checkbox_container = create_checkbox_container();
    var checkbox = create_checkbox_element(toggled_variable, variable_name);
    var checkbox_label = create_checkbox_label(title, variable_name);

    checkbox_container.appendChild(checkbox);
    checkbox_container.appendChild(checkbox_label);

    return;
}


function create_checkbox_container() {
    var legend = document.getElementById("legend_div"); // depends on create_legend_div()
    var checkbox_container = document.createElement("div");
    checkbox_container.className = 'col-sm-1';
    legend.appendChild(checkbox_container);
    return checkbox_container;
}


function create_checkbox_element(toggled_variable, variable_name) {
    var checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'checkbox';
    checkbox.id = variable_name;
    checkbox.checked = toggled_variable;
    checkbox.onclick = function () {cache_checkbox_value(this, variable_name);};
    return checkbox;
}


function create_checkbox_label(title, variable_name) {
    var checkbox_label = document.createElement('label');
    checkbox_label.htmlFor = variable_name;
    checkbox_label.appendChild(document.createTextNode(title));
    return checkbox_label;
}


// returns list of telescopes at a given site
// e.g. ['tfn.aqwa.0m4a', 'tfn.aqwa,0m4b']
function list_teles_at_site(site, sites) {
    var list_teles = []; // keep running list of telescopes at the passed site
    for (const siteKey in sites) {
        // find the correct site in sites
        if (sites[siteKey].__str__ == site) {
            // add each telescope to running list
            for (const enclosureKey in sites[siteKey].enclosure_set) {
                for (const teleKey in sites[siteKey].enclosure_set[enclosureKey].telescope_set) {
                    const telescope_name =
                        sites[siteKey].enclosure_set[enclosureKey].telescope_set[teleKey].__str__;
                    list_teles.push(telescope_name);
                }
            }
            continue;
        }
    }
    return list_teles.sort();
}


function groups_data_sites(sites) {
    var groups = [];
    var site = '';
    var teles_at_site = [];
    for (const key in sites) {
        site = sites[key].__str__;
        teles_at_site = list_teles_at_site(site, sites);
        groups.push({id : site, content : sites[key].name,
            nestedGroups : teles_at_site, is_observation : false, subgroupOrder: function(a,b) {return b.subgroupOrder - a.subgroupOrder;},
            longitude : -sites[key].enclosure_set[0].telescope_set[0].long});
    }
    return groups;
}


function groups_data_telescopes_by_site(site, sites, admin) {
    var groups = [];
    var telescope_name = '';
    var teles_at_site = list_teles_at_site(site, sites);
    var style_name = '';
    var telescope_data;
    for (const t in teles_at_site) {
        telescope_name = teles_at_site[t];
        telescope_data = get_telescope_data(telescope_name, sites);
        style_name = set_telescope_class_name(telescope_name);
        if (!telescope_is_schedulable(telescope_data)) {
            style_name = style_name + ' not-schedulable';
        }
        if (admin) {
            style_name = style_name + ' admin';
        } else {
            style_name = style_name + ' not-admin';
        }
        groups.push({id : telescope_name, content : telescope_name, nestedInGroup: site, treeLevel: 1,
            className: style_name, subgroupOrder: function(a,b) {return b.subgroupOrder - a.subgroupOrder;},
            is_observation: false});
    }
    return groups;
}


function set_telescope_class_name(telescope){
    var class_name = '';

    if (['0m4a', '0m4b', '0m4c'].indexOf(telescope.split('.')[2]) >= 0 ) {
            class_name = 'icon0';
        } else if (['0m8a', '1m0a'].indexOf(telescope.split('.')[2]) >= 0 ) {
            class_name = 'icon1';
        } else {
            class_name = 'icon2';
        }

    return class_name;
}


function groups_data_telescopes_all(sites, admin) {
    var groups = [];
    var site = '';
    for (const key in sites) {
        site = sites[key].__str__;
        groups = groups.concat(groups_data_telescopes_by_site(site, sites, admin));
    }
    return groups;
}


function weather_at_sites(weatherdata, timelineBounds) {
    var to_append = [];
    var eventTimeData = {};
    var revisedTimeData = {};
    for (const key in weatherdata) {
        revisedTimeData = make_dates(weatherdata[key]._source.timestamp,
                                    weatherdata[key]._source.timestampmeasured,
                                    timelineBounds);
        to_append.push({id: weatherdata[key]._id,
                         content : '',
                         title : weatherdata[key]._source.value_string,
                         start : revisedTimeData.start.toISOString(),
                         end : revisedTimeData.end.toISOString(),
                         group : weatherdata[key]._source.site,
                         type: 'background',
                         className : 'weather',
                         is_observation: false});
    }
    return to_append;
}


function adjust_dates_to_fit_timeline(eventTimeData, timelineBounds) {
    if (eventTimeData.start < timelineBounds.start) {
       eventTimeData.start = timelineBounds.start;
    }
    if (eventTimeData.end > timelineBounds.end) {
        eventTimeData.end = timelineBounds.end;
    }
    return eventTimeData;
}


function add_weather_event_to_each_telescope(site, sites, weather_event, timelineBounds) {
    var to_append = [];
    var revisedTimeData = make_dates(weather_event._source.timestamp,
                                    weather_event._source.timestampmeasured,
                                    timelineBounds);
    var telescope_name = '';
    var teles_at_site = list_teles_at_site(site, sites);
    for (const t in teles_at_site) {
        telescope_name = teles_at_site[t];
        to_append.push({id: weather_event._id.concat(telescope_name),
                         content : '',
                         title : weather_event._source.value_string,
                         start : revisedTimeData.start.toISOString(),
                         end : revisedTimeData.end.toISOString(),
                         group : telescope_name,
                         type: 'background',
                         className : 'weather',
                         is_observation: false});
    }
    return to_append;
}


function add_weather_events_to_telescopes_all(sites, weatherdata, timelineBounds) {
    var to_append = [];
    var site = '';
    for (const key in weatherdata) {
        site = weatherdata[key]._source.site;
        to_append = to_append.concat(
                    add_weather_event_to_each_telescope(site, sites, weatherdata[key], timelineBounds));
    }
    return to_append;
}


function observation_has_ended(observation_end_time) {
    var now_utc = new Date(utc_timestamp());
    var observation_end = new Date(observation_end_time);
    return observation_end < now_utc;
}


function assign_group(observation) {
    var site_enclosure_telescope = '';
    site_enclosure_telescope = observation.site + '.'
                                + observation.enclosure + '.'
                                + observation.telescope;
    return site_enclosure_telescope;
}

// JON'S FUNCTION
function add_scheduled_observation(schedule, subgroup_name, subgroup_order) {
    var to_append = [];
    for(const resource in schedule['resources'])
    {
        var tel_name = resource.split(".");
        tel_name.reverse();
        var group_name = tel_name.join(".");
        for(const reservation in schedule['resources'][resource]['reservations'])
        {
            var observation = schedule['resources'][resource]['reservations'][reservation];
            to_append.push({id: observation.request_id + "-" + subgroup_order,
                     content : '',
                     title : observation.request_id.toString(),
                     start : observation.start,
                     end : observation.end,
                     className : "observation-" + subgroup_order,
                     group : group_name,
                     subgroup: subgroup_name,
                     subgroupOrder: subgroup_order,
                     is_observation: true});
        }
    }
    return to_append;
}


// prepares info for observation mouseover ('tooltip')
function add_request_group_id_to_tooltip(request_group_id) {
    if (request_group_id == '') {
        return '';
    } else {
        return '<b>RequestGroup #: </b>' + request_group_id + '<br/>';
    }
}

function add_percentage_complete_to_tooltip(percentage_complete) {
    return percentage_complete + '% complete <br/>';
}

function add_observation_details_to_tooltip(observation) {
    let detail_text = '<b>proposal:</b> ' + observation.proposal
                + '<br/><b>submitter:</b> ' + observation.submitter
                + '<br/><b>name:</b> ' + observation.name
                + '<br/><b>acceptability_threshold:</b> ' + observation.acceptability_threshold + '%<br/>';
    if (observation.request_id != '') {
        detail_text += '<b>request_id:</b> ' + observation.request_id + '<br/>';
    }
    return detail_text;
}


function count_total_configurations(observation){
    return observation.configurations.length;
}

function count_completed_configurations(observation){
    return observation.configurations.filter(x => x.state == 'COMPLETED').length;
}

function count_total_configuration_time(observation) {
    var total_time = 0;
    for (const config of observation.configurations) {
        if (config.type.includes('REPEAT') && config.repeat_duration != undefined) {
            total_time += parseFloat(config.repeat_duration);
        }
        else {
            for (const ins_config of config.instrument_configs) {
                total_time += parseFloat(ins_config.exposure_time) * parseInt(ins_config.exposure_count);
            }
        }
    }
    return total_time;
}

function count_completed_configuration_time(observation) {
    var completed_time = 0;
    for (const config of observation.configurations) {
        if (config.type.includes('REPEAT')) {
            if (config.summary.end != undefined && config.summary.start != undefined) {
                var end = new Date(config.summary.end);
                var start = new Date(config.summary.start);
                completed_time += (end - start) / 1000;
            }
        }
        else if (config.summary.time_completed != undefined) {
            completed_time += config.summary.time_completed;
        }
    }
    return completed_time;
}

function get_percentage_complete(observation) {    
    var completed_configurations = count_completed_configurations(observation);
    var total_configurations = count_total_configurations(observation);
    var completed_time = count_completed_configuration_time(observation);
    var total_time = count_total_configuration_time(observation);

    // if all configs are COMPLETED, then observation is 100% complete
    if (completed_configurations == total_configurations) {
        return 100.0;
    }
    
    if (observation.is_calibrate || total_time == 0) { 
        var completed = completed_configurations;
        var total = total_configurations;
    } else {
        var completed = completed_time;
        var total = total_time;
    }
    return ((completed / total) * 100).toFixed(1);

}

function get_configs_end_time(observation) {
    // Among all configs, find the latest summary.end as configs_end_time
    let configs_end_time = 0;
    for (const config of observation.configurations){
        // safe comparison, even if end can be undefined
        if (new Date(config.summary.end) > new Date(configs_end_time)){
            configs_end_time = config.summary.end;
        }
    }
    if (new Date(configs_end_time) < new Date(observation.start)){
        configs_end_time = observation.modified;
    }
    return configs_end_time;
}


function add_observation_to_timeline(observation, admin, hidePastPending, hideNotAttempted, weatherData) {
    var class_name = '';
    var observation_start = observation.start;
    var observation_end = observation.end;
    var label_text = add_request_group_id_to_tooltip(observation.request_group_id);
    var acceptability_threshold = observation.acceptability_threshold;
    var group_id = assign_group(observation);

    // label_text = RequestGroup #
    //            + complete%      if ended
    //            + 'Aborted'      if ended and ABORTED
    //            + details        if admin or owner

    // for past observations
    if (observation_has_ended(observation_end)) {

        // Past observations where all configs are PENDING
        let isPastPending = false;
        if (observation.configurations.every(x => x.state == 'PENDING')) {
            isPastPending = true;
            if (hidePastPending) {
                return 'hide';
            }
            else {
                class_name = 'observation-past-pending';
            }
        }

        var percentage_complete = get_percentage_complete(observation);
        label_text += add_percentage_complete_to_tooltip(percentage_complete);

        // if observation is ABORTED -> 'observation-aborted'
        if (observation.state == 'ABORTED'){
            class_name = 'observation-aborted';
            if (admin) {
                label_text += '<b>Aborted</b><br/>';
            }
            observation_end = get_configs_end_time(observation);
        }

        else if ( admin && observation.state == 'NOT_ATTEMPTED') {
            // hide auto-focus observations or observations that occur within a weather window
            if (hideNotAttempted || observation.proposal.includes('focus'))
            {
                return 'hide';
            }
            for (let weatherEvent of weatherData) {
                if (observation.start >= weatherEvent.start && observation.start <= weatherEvent.end) {
                    return 'hide';
                }
            }
            class_name = 'observation-not-attempted';
        }

        // if have an ATTEMPTED config -> 'observation-future' (invalid observation state. observation cache is out
        // of date) or if past observation was not attempted, keep same colors as the future observations.
        else if (observation.configurations.some(x => x.state == 'ATTEMPTED') || isPastPending){
            if (observation.is_calibrate){
                class_name = 'observation-calibrating-future';
            } else {
                class_name = 'observation-future';
            }
        }

        // normal cases -> check calibrate and completed/failed
        else {
            if (percentage_complete >= acceptability_threshold) {
                if (observation.is_calibrate) {
                    class_name = 'observation-calibrating-past';
                } else {
                    class_name = 'observation-completed';
                }
            } else {
                if (observation.is_calibrate) {
                    class_name = 'observation-calibrating-failed';
                } else {
                    class_name = 'observation-failed';
                }
            }
            observation_end = get_configs_end_time(observation)
        }
        
    }

    // for future observations
    else{
        if (observation.is_calibrate){
            class_name = 'observation-calibrating-future';
        } else {
            class_name = 'observation-future';
        }
    }

    if (observation.is_owner || admin) {
        label_text += add_observation_details_to_tooltip(observation);
        class_name += ' observation-pointer';
    }
    
    var to_append = {id: observation.id,
                     content : '',
                     title : label_text,
                     start : observation_start,
                     end : observation_end,
                     className : class_name,
                     group : group_id,
                     is_observation: true,
                     is_owner: observation.is_owner,
                     request_num : observation.request_id};

    if (to_append.className.includes('not-attempted')) {
        to_append.end = to_append.start;
    }

    if (observation.is_owner) { //add background highlight for owned observations
        to_append = [to_append,
                    {id: observation.id + "owner",
                    content: '',
                    start: observation_start,
                    end: observation_end,
                    group: group_id,
                    type: 'background',
                    className: 'owned',
                    is_observation: false}];
    }
    return to_append;
}

function prepare_observation_data(observations, admin, hidePastPending, hideNotAttempted, weatherData) {
    var all_observation_data = [];
    var to_concat = [];
    for(const key in observations){
        // filter weather data for specific site/encl/tel
        let telWeatherData = weatherData.filter(datum => datum.group === assign_group(observations[key]))
        to_concat = add_observation_to_timeline(observations[key], admin, hidePastPending, hideNotAttempted, telWeatherData);
        // Optionally skip any observations we decided to hide
        if (to_concat === 'hide') {
            continue;
        } else {
		    all_observation_data = all_observation_data.concat(to_concat);
		}
    }
    return all_observation_data;
}

function sun_up_at_sites(sun_up_data) {
    var to_append = [];
    for (const key in sun_up_data) {
        to_append.push({id : 'sun_up' + key,
                        content : '',
                        title : 'Sun up',
                        start : sun_up_data[key].start,
                        end : sun_up_data[key].end,
                        group : sun_up_data[key].id,
                        type : 'background',
                        className : 'sun-up',
                        is_observation: false});
    }
    return to_append;
}


function add_sun_up_event_to_each_telescope(site, sites, sun_up_event, event_key) {
    var to_append = [];
    var telescope_name = '';
    var teles_at_site = list_teles_at_site(site, sites);
    for (const t in teles_at_site) {
        telescope_name = teles_at_site[t];
        to_append.push({id: 'sun_up' + event_key + telescope_name,
                             content : '',
                            title : 'Sun up',
                            start : sun_up_event.start,
                            end : sun_up_event.end,
                            group : telescope_name,
                            type : 'background',
                            className : 'sun-up',
                            is_observation: false});
    }
    return to_append;
}


function add_sun_up_events_to_telescopes_all(sites, sun_up_data) {
    var to_append = [];
    var site = '';
    for (const key in sun_up_data) {
        site = sun_up_data[key].id;
        to_append = to_append.concat(add_sun_up_event_to_each_telescope(site, sites,
                    sun_up_data[key], key));
    }
    return to_append;
}


// returns all info about a given telescope
// takes telescope name e.g. 'ogg.clma.0m4c'
function get_telescope_data(telescope, sites) {
    var site_name = telescope.split('.')[0];
    var enclosure_name = telescope.split('.')[1];
    var telescope_name = telescope.split('.')[2];
    for (const site_key in sites) {
        if (sites[site_key].code === site_name) {
            for (const enclosure_key in sites[site_key].enclosure_set) {
                if (sites[site_key].enclosure_set[enclosure_key].code === enclosure_name) {
                    for (const telescope_key in sites[site_key].enclosure_set[enclosure_key].telescope_set) {
                        if (sites[site_key].enclosure_set[enclosure_key].telescope_set[telescope_key].code === telescope_name) {
                            return sites[site_key].enclosure_set[enclosure_key].telescope_set[telescope_key];
                        }
                    }
                }
            }
        }
    }
}


function telescope_is_schedulable(telescope) {
    var schedulable_flag = false;
    for (const key in telescope.instrument_set) {
        if (telescope.instrument_set[key].state === 'SCHEDULABLE') {
            schedulable_flag = true;
        }
    }
    return schedulable_flag;
}


function weather_event_tooltip(mouse_time, mouse_group, weatherdata) {
    var tooltip_text_list = [];
    let new_string = '';
    for (const key in weatherdata) {
        if (weatherdata[key]._source.site === mouse_group) {
            if (mouseover_time_matches_event_time(mouse_time,
                                                weatherdata[key]._source.timestamp,
                                                weatherdata[key]._source.timestampmeasured)) {
                new_string = weatherdata[key]._source.value_string;
                if (tooltip_text_list.indexOf(new_string) === -1) {
                    tooltip_text_list.push(new_string);
                }
            }
        }
    }
    return tooltip_text_list.join(" & ");
}


function mouseover_time_matches_event_time(mouse_time, event_start, event_end) {
    var mouse_time_date = new Date(mouse_time);
    var start_time_date = new Date(event_start);
    var end_time_date = new Date(event_end);
    if (start_time_date <= mouse_time_date) {
        if (end_time_date >= mouse_time_date) {
            return true;
        }
    }
    return false;
}


function downtime_tooltip(mouse_time, mouse_group, downtimedata) {
    var telescope_name = '';
    for (const key in downtimedata) {
        telescope_name = assign_group(downtimedata[key]);
        if (telescope_name === mouse_group) {
            if (mouseover_time_matches_event_time(mouse_time, downtimedata[key].start, downtimedata[key].end)){
                return downtimedata[key].reason;
            }

        }
    }
    return '';
}


function sequencer_tooltip(mouse_time, mouse_group, sequencerdata) {
    for (const key in sequencerdata) {
        if (sequencerdata[key].telescope === mouse_group) {
            return 'Sequencer in ' + sequencerdata[key].title + ' state';
        }
    }
}


function click_thru_to_observation(admin, properties, timelinedata, obsPortalUrl) {
    var item = properties.item != null ? timelinedata.get(properties.item) : null;
    if (admin) {
      if (properties.what == "group-label") {
        var site_code = properties.group.split('.');
        if (site_code.length == 3) {
            var start_time = vis.moment.utc().add(-1,'d').format('YYYY-MM-DD');
            var end_time = vis.moment.utc().add(2,'d').format('YYYY-MM-DD');

            let observation_url = obsPortalUrl + "/observations/?order=" + "&site=" + site_code[0] + "&enclosure=" + site_code[1] +
                                  "&telescope=" + site_code[2] + "&is_too=" + "&state=PENDING" + "&aborted=" + "&time_span="
                                  + "&start_after=" + start_time + "&start_before=" + end_time + "&request_num=" + "&tracking_num=";

            window.open(observation_url);

        }
      } else if (properties.what == "item") {
        if (item && item.is_observation) {
            const url = obsPortalUrl + "/observations/" + properties.item + "/";
            window.open(url);
        }
      }
    } else if (properties.what == "item") {
        if (item && item.is_observation) {
            if (item.is_owner) {
                const url = obsPortalUrl + "/observations/" + properties.item + "/";
                window.open(url);
            }
        }
    }

    return;
}


function click_thru_to_request(admin, properties, timelinedata, obsPortalUrl) {
    var item = timelinedata.get(properties.item);
    if (!item) {
        return;
    }
    if (admin) {
        var request_num = Number(item.request_num);
        if (request_num != '') {
            window.open(obsPortalUrl + "/requests/" + request_num + "/");
        }
    } else if (item.is_owner) {
        var request_num = Number(item.request_num);
        if (request_num != '') {
            window.open(obsPortalUrl + "/requests/" + request_num + "/");
        }
    }
    return;
}


function add_tooltip(properties, weatherdata, downtimedata, sequencerdata) {
    if (properties.what === "background" && properties.group != null) {
        var mouse_time = properties.time;
        var mouse_group = properties.group;
        var tooltip_text = downtime_tooltip(mouse_time, mouse_group, downtimedata);
        if (tooltip_text === '') {
            const mouse_site = properties.group.split('.')[0]; // extract site from group
            tooltip_text = weather_event_tooltip(mouse_time, mouse_site, weatherdata);
            if (tooltip_text === '') {
                tooltip_text = sequencer_tooltip(mouse_time, mouse_group, sequencerdata);
            }
        }
        document.querySelectorAll('.vis-background').forEach(function(element) {
            element.setAttribute('data-bs-toggle', 'tooltip');
            element.setAttribute('title', tooltip_text || '');
        });
    }
}


function set_timeline_options(daysIntoPast, daysIntoFuture) {
    // Set the max zoom to be slightly larger than the range of the data since
    // it's nicer for the user.
    let zoomMax = (daysIntoPast + daysIntoFuture) * 24 * 60 * 60 * 1000 + 4;
    var options = {
        groupOrder: 'longitude',
        stack: false,
        moment: function(date) {
            return vis.moment(date).utc();
        },
        orientation: {
            axis: 'both'
        },
        selectable: false,
        zoomMax: zoomMax
    };
    var now = new Date(utc_timestamp());
    options.start = new Date(now.getTime() - daysIntoPast * 24 * 60 * 60 * 1000);
    options.end = new Date(now.getTime() + daysIntoFuture * 24 * 60 * 60 * 1000);

    // look for timeline start/end times in local storage
    if (('start' in localStorage) && ('end' in localStorage)) {
        let range = daysIntoPast + daysIntoFuture;
        let scaleStart = daysIntoPast / range;
        let scaleEnd = daysIntoFuture / range;
        var timeline_bounds = get_timeline_bounds(scaleStart, scaleEnd);
        options.start = timeline_bounds.start;
        options.end = timeline_bounds.end;
    }
    localStorage.removeItem('start');
    localStorage.removeItem('end');
    return options;
}


function add_downtime_data(downtimedata, timelineBounds) {
    var to_append = [];
    for (const key in downtimedata) {
        const eventTimes = make_dates(downtimedata[key].start,
                                    downtimedata[key].end,
                                    timelineBounds);
        const telescope_name = assign_group(downtimedata[key]);
        to_append.push({id : 'downtime_block' + key,
                        content : '',
                        title : downtimedata[key].reason,
                        start : eventTimes.start.toISOString(),
                        end : eventTimes.end.toISOString(),
                        group : telescope_name,
                        type : 'background',
                        className : 'downtime',
                        is_observation : false});
    }
    return to_append;
}


function make_dates(event_start, event_end, timelineBounds) {
    var start_date = new Date(event_start);
    var end_date = new Date(event_end);
    var eventTimeData = {'start':start_date, 'end':end_date};
    var revisedTimeData = adjust_dates_to_fit_timeline(eventTimeData, timelineBounds);
    return revisedTimeData;
}


function add_sequencer_data(sequencer_data, timelineBounds) {
    var to_append = [];
    for (const key in sequencer_data) {
        const eventTimes = make_dates(sequencer_data[key]['start_time'],
                                sequencer_data[key]['end_time'],
                                timelineBounds);
        to_append.push({id: 'sequencer_data' + key,
                        content: '',
                        title: 'Sequencer is in ' + sequencer_data[key]['title']
                                + ' mode',
                        start: eventTimes.start,
                        end: eventTimes.end,
                        group: sequencer_data[key]['telescope'],
                        type: 'background',
                        className: 'downtime',
                        is_observation: false});
    }
    return to_append;
}


export {
   utc_timestamp,
   cache_timeline_width,
   get_timeline_bounds,
   create_legend_div,
   create_checkbox,
   list_teles_at_site,
   groups_data_telescopes_by_site,
   groups_data_sites,
   groups_data_telescopes_all,
   weather_at_sites,
   add_weather_event_to_each_telescope,
   add_weather_events_to_telescopes_all,
   observation_has_ended,
   sun_up_at_sites,
   add_sun_up_event_to_each_telescope,
   add_sun_up_events_to_telescopes_all,
   count_total_configurations,
   count_completed_configurations,
   count_total_configuration_time,
   count_completed_configuration_time,
   get_percentage_complete,
   get_configs_end_time,
   assign_group,
   add_request_group_id_to_tooltip,
   add_percentage_complete_to_tooltip,
   add_observation_details_to_tooltip,
   add_observation_to_timeline,
   prepare_observation_data,
   telescope_is_schedulable,
   get_telescope_data,
   set_telescope_class_name,
   weather_event_tooltip,
   adjust_dates_to_fit_timeline,
   make_dates,
   add_downtime_data,
   add_sequencer_data,
   add_scheduled_observation,
   click_thru_to_observation,
   click_thru_to_request,
   add_tooltip,
   set_timeline_options
};
//    list_teles_at_site: list_teles_at_site,
//    groups_data_telescopes_by_site: groups_data_telescopes_by_site,
//    groups_data_sites: groups_data_sites,
//    groups_data_telescopes_all: groups_data_telescopes_all,
//    weather_at_sites: weather_at_sites,
//    add_weather_event_to_each_telescope: add_weather_event_to_each_telescope,
//    add_weather_events_to_telescopes_all: add_weather_events_to_telescopes_all,
//    observation_has_ended: observation_has_ended,
//    sun_up_at_sites: sun_up_at_sites,
//    add_sun_up_event_to_each_telescope: add_sun_up_event_to_each_telescope,
//    add_sun_up_events_to_telescopes_all: add_sun_up_events_to_telescopes_all,
//    count_total_configurations: count_total_configurations,
//    count_completed_configurations: count_completed_configurations,
//    count_total_configuration_time: count_total_configuration_time,
//    count_completed_configuration_time: count_completed_configuration_time,
//    get_percentage_complete: get_percentage_complete,
//    get_configs_end_time: get_configs_end_time,
//    assign_group: assign_group,
//    add_request_group_id_to_tooltip: add_request_group_id_to_tooltip,
//    add_percentage_complete_to_tooltip: add_percentage_complete_to_tooltip,
//    add_observation_details_to_tooltip: add_observation_details_to_tooltip,
//    add_observation_to_timeline: add_observation_to_timeline,
//    prepare_observation_data: prepare_observation_data,
//    telescope_is_schedulable: telescope_is_schedulable,
//    get_telescope_data: get_telescope_data,
//    set_telescope_class_name: set_telescope_class_name,
//    weather_event_tooltip: weather_event_tooltip,
//    adjust_dates_to_fit_timeline: adjust_dates_to_fit_timeline,
//    make_dates: make_dates,
//    add_downtime_data: add_downtime_data
// }
